// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Orders Page Styles - Beautiful Design */

@keyframes ordersPageFade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.orders-page {
  padding: 0;
  max-width: 1400px;
  margin: 0 auto;
  min-height: calc(100vh - 80px);
  background: transparent;
  font-family: var(--font-body);
  animation: ordersPageFade 0.35s ease-out;
}

/* Header Section */
.orders-header {
  margin-bottom: 2.5rem;
  text-align: center;
}

/* Sort Container */
.orders-sort-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

/* Unified surface from sort controls through orders list */
.orders-content-surface {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  padding: 24px;
  margin-bottom: 2rem;
}

/* Shared rounded surface only for controls area (sort + filters) */
.orders-controls-surface {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
  margin-bottom: 2rem;
  box-shadow: none;
}

.orders-csv-export-wrap {
  margin-left: auto;
  flex-shrink: 0;
}

.orders-csv-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.orders-more-filters-inline {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.orders-title {
  font-size: 3rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 1rem;
  letter-spacing: -0.02em;
  position: relative;
  display: inline-block;
}

/* Filters Section */
.orders-filters {
  background: var(--bg-secondary);
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-color);
  border: 1px solid var(--border-color);
}

.filters-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.25rem;
  align-items: end;
}

.filter-group {
  display: flex;
  flex-direction: column;
  position: relative;
}

.orders-page .search-panel .filter-group {
  gap: 4px;
}

.orders-page .search-panel .filter-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--text-secondary);
  margin-bottom: 0 !important;
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  text-align: left !important;
  padding-left: 2px;
  letter-spacing: 0.35px;
}

.orders-page .search-panel .filter-input,
.orders-page .search-panel .filter-select {
  border-radius: 10px;
  background: var(--bg-primary);
}

.filter-input,
.filter-select {
  width: 100%;
  padding: 0.875rem 1.125rem;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  font-size: 0.9375rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: var(--bg-primary);
  color: var(--text-primary);
}

.filter-input:focus,
.filter-select:focus {
  outline: none;
  border-color: var(--accent-color);
  background: var(--bg-secondary);
  box-shadow: 0 0 0 3px var(--nav-active-bg);
  transform: translateY(-1px);
}

.filter-input::placeholder {
  color: #94a3b8;
}

/* Search Panel Wrapper */
.search-panel-wrapper {
  position: relative;
  margin-bottom: 0;
}

/* More Filters Menu */
.more-filters-wrapper {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
}

.more-filters-menu {
  position: relative;
  display: inline-block;
}

.more-filters-button {
  width: 40px;
  height: 40px;
  padding: 0;
  border: 2px solid var(--border-color);
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  text-align: center;
  font-family: inherit;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.more-filters-button:hover {
  border-color: var(--accent-color);
  background: var(--bg-primary);
  color: var(--accent-color);
}

.more-filters-button.has-filters {
  border-color: var(--accent-color);
  background: rgba(79, 70, 229, 0.05);
  color: var(--accent-color);
}

.more-filters-icon {
  font-size: 1.25rem;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 1px;
  transform: rotate(90deg);
}

.more-filters-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  background: var(--accent-primary);
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: none;
}

.more-filters-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 280px;
  background: var(--bg-primary);
  border-radius: 12px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
  z-index: 1000;
  overflow: hidden;
}

@media (max-width: 768px) {
  .orders-content-surface {
    border-radius: 12px;
    padding: 16px;
  }

  .orders-controls-surface {
    border-radius: 0;
    padding: 0;
  }

  .orders-sort-container {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .orders-more-filters-inline {
    width: 100%;
    justify-content: flex-end;
  }

  .more-filters-menu {
    width: 100%;
  }

  .more-filters-dropdown {
    left: 0;
    right: 0;
    width: 100%;
    min-width: 0;
  }

  .more-filters-wrapper {
    top: 0.75rem;
    right: 0.75rem;
  }

  .more-filters-button {
    width: 36px;
    height: 36px;
  }

  .more-filters-icon {
    font-size: 1.1rem;
  }
}

.more-filters-header {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-primary);
}

.more-filters-title {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--text-secondary);
  text-transform: none;
  letter-spacing: 0;
}

.more-filters-content {
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.more-filters-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.more-filters-label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 0.25rem;
}

.more-filters-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid var(--border-color);
  border-radius: 8px;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: inherit;
}

.more-filters-input:focus {
  outline: none;
  border-color: var(--accent-color);
  background: var(--bg-secondary);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.more-filters-checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.5rem 0;
  -webkit-user-select: none;
          user-select: none;
}

.more-filters-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: var(--accent-primary);
  flex-shrink: 0;
}

.more-filters-checkbox-text {
  font-size: 0.9375rem;
  font-weight: 500;
  color: var(--text-primary);
  transition: color 0.3s ease;
}

.more-filters-checkbox-label:hover .more-filters-checkbox-text {
  color: var(--accent-primary);
}

.filters-actions {
  display: flex;
  gap: 0.875rem;
  align-items: center;
}

.search-button,
.reset-button {
  padding: 0.875rem 1.75rem;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.9375rem;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  position: relative;
  overflow: hidden;
}

.search-button {
  background: var(--accent-color);
  color: white;
  box-shadow: var(--shadow-sm);
}

.search-button:hover:not(:disabled) {
  transform: translateY(-2px);
  background: var(--accent-hover);
  box-shadow: var(--shadow-md);
}

.search-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.reset-button {
  background: var(--bg-primary);
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
}

.reset-button:hover {
  background: var(--nav-hover-bg);
  border-color: var(--text-secondary);
  color: var(--text-primary);
  transform: translateY(-2px);
}

.button-icon {
  font-size: 1rem;
  display: inline-block;
  transition: transform 0.3s ease;
}

.search-button:hover .button-icon {
  transform: rotate(15deg) scale(1.1);
}

.reset-button:hover .button-icon {
  transform: rotate(180deg);
}

/* Error Message */
.error-message {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #dc2626;
  padding: 1.25rem 1.75rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  border: 2px solid #fecaca;
  font-weight: 600;
  text-align: center;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.15);
  animation: slideUp 0.4s ease-out 0.2s backwards;
}



/* Grid is handled by cards.css */

/* Empty State */
.orders-cards-wrapper .empty-state {
  padding: 4rem 2rem;
  text-align: center;
  background: transparent;
  border-radius: 16px;
  box-shadow: none;
  border: 1px solid rgba(226, 232, 240, 0.8);
}

/* Loading State */
.orders-cards-wrapper .loading-state {
  padding: 4rem 2rem;
  text-align: center;
  background: transparent;
  border-radius: 16px;
  box-shadow: none;
  border: 1px solid rgba(226, 232, 240, 0.8);
}

/* Pagination */
.orders-cards-wrapper .pagination {
  margin-top: 0;
  border-top: 1px solid var(--border-color);
  border-radius: 12px;
  background: transparent;
  border-left: none;
  border-right: none;
  border-bottom: none;
  box-shadow: none;
}

/* Table Section - keeping for backward compatibility if needed */
.orders-table-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08),
    0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  border: 1px solid rgba(226, 232, 240, 0.8);
  animation: slideUp 0.4s ease-out 0.25s backwards;
}

.table-responsive {
  overflow-x: auto;
}

/* Loader removed to avoid global conflicts */

/* Table Styles */
.orders-table {
  width: 100%;
  border-collapse: collapse;
}

.orders-table th,
.orders-table td {
  vertical-align: middle;
}

.table-header {
  background: var(--bg-primary);
  border-bottom: 3px solid var(--border-color);
}

.table-header th {
  padding: 0.8rem 0.9rem;
  text-align: left;
  font-size: 0.8125rem;
  font-weight: 700;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  white-space: nowrap;
  position: relative;
}

.table-header th::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 0;
  height: 3px;
  background: var(--accent-primary);
  transition: width 0.3s ease;
}

.table-header th:hover::after {
  width: 100%;
}

.table-body {
  background: white;
}

.table-row {
  border-bottom: 1px solid #eef2f7;
  transition: background-color 0.2s ease;
  animation: fadeInRow 0.28s ease-out backwards;
}

@keyframes fadeInRow {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.table-row:nth-child(1) {
  animation-delay: 0.1s;
}

.table-row:nth-child(2) {
  animation-delay: 0.15s;
}

.table-row:nth-child(3) {
  animation-delay: 0.2s;
}

.table-row:nth-child(4) {
  animation-delay: 0.25s;
}

.table-row:nth-child(5) {
  animation-delay: 0.3s;
}

.table-row:hover {
  background: var(--bg-secondary);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  transform: none;
}

.table-cell {
  padding: 0.7rem 0.9rem;
  vertical-align: middle;
}

.table-cell-id {
  width: 130px;
}

.table-cell-title {
  min-width: 220px;
  max-width: 320px;
}

.table-cell-client {
  min-width: 160px;
  max-width: 220px;
  text-align: left;
  vertical-align: middle;
}

.table-cell-status {
  width: 180px;
}

.table-cell-date {
  width: 170px;
  white-space: nowrap;
}

.table-cell-actions {
  width: 130px;
  text-align: center;
}

.order-id {
  font-family: 'Monaco', 'Consolas', 'Liberation Mono', monospace;
  font-size: 0.8125rem;
  color: var(--text-secondary);
  background: var(--nav-hover-bg);
  padding: 0.35rem 0.65rem;
  border-radius: 8px;
  display: inline-block;
  cursor: help;
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.order-id:hover {
  background: var(--nav-hover-bg);
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.order-title {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.9375rem;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-client {
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.25;
}

.order-date {
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.3;
}

/* Status Badges - styles moved to status-badge.css */

/* Action Links */
.action-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background: var(--accent-color);
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
  position: relative;
  overflow: hidden;
}

.action-link::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.action-link:hover::before {
  width: 300px;
  height: 300px;
}

.action-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  text-decoration: none;
  color: white;
}

.action-icon {
  font-size: 1rem;
  transition: transform 0.3s ease;
}

.action-link:hover .action-icon {
  transform: translateX(4px);
}

/* Empty State */
.empty-state {
  padding: 4rem 2rem;
  text-align: center;
}

.empty-state-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.empty-state-icon {
  font-size: 4.5rem;
  margin-bottom: 0.5rem;
  opacity: 0.6;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-10px);
  }
}

.empty-state-text {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-top: 0.5rem;
}

.empty-state-subtext {
  font-size: 0.9375rem;
  color: var(--text-secondary);
  margin-top: 0.25rem;
}

.empty-state td {
  padding: 4rem 2rem;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-top: 2px solid var(--border-color);
  background: var(--bg-primary);
}

.pagination-button {
  background: var(--accent-color);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: var(--shadow-sm);
  position: relative;
  overflow: hidden;
}

.pagination-button::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.pagination-button:hover:not(:disabled)::before {
  width: 300px;
  height: 300px;
}

.pagination-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.pagination-button:disabled {
  background: var(--border-color);
  color: #94a3b8;
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.pagination-icon {
  font-size: 1rem;
  transition: transform 0.3s ease;
}

.pagination-button:hover:not(:disabled) .pagination-icon {
  transform: translateX(-4px);
}

.pagination-button.next:hover:not(:disabled) .pagination-icon {
  transform: translateX(4px);
}

.pagination-info {
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 0.9375rem;
  background: white;
  padding: 0.75rem 1.5rem;
  border-radius: 10px;
  border: 2px solid var(--border-color);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .filters-form {
    grid-template-columns: repeat(2, 1fr);
  }

  .orders-page {
    padding: 1.5rem;
  }

  .orders-cards-grid {
    gap: 0.625rem;
    padding: 0.875rem 1.25rem;
  }
}

@media (max-width: 768px) {
  .orders-page {
    padding: 1rem;
  }

  .orders-title {
    font-size: 2.25rem;
  }

  .orders-title::after {
    width: 60px;
  }

  .filters-form {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .filters-actions {
    flex-direction: column;
  }

  .orders-filters {
    padding: 1.5rem;
  }

  .orders-cards-grid {
    gap: 0.5rem;
    padding: 0.75rem 1rem;
  }

  .orders-cards-wrapper .order-card {
    padding: 0.625rem 0.875rem;
    flex-direction: column;
    align-items: flex-start;
  }

  .orders-cards-wrapper .order-card-main {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    width: 100%;
  }

  .orders-cards-wrapper .order-card-sections {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    width: 100%;
  }

  .orders-cards-wrapper .order-card-section-companies {
    text-align: left;
  }

  .orders-cards-wrapper .order-card-footer {
    padding-left: 0;
    padding-top: 0.5rem;
    border-left: none;
    border-top: 1px solid #f3f4f6;
    width: 100%;
    align-items: flex-start;
  }

  .orders-cards-wrapper .order-card-meta {
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }

  .orders-cards-wrapper .order-card-sections {
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
  }

  .orders-cards-wrapper .order-card-section-companies {
    grid-column: 1 / -1;
    text-align: right;
  }

  .orders-cards-wrapper .order-card-title {
    font-size: 1.0625rem;
  }

  .orders-cards-wrapper .order-card-description {
    font-size: 0.9375rem;
  }

  .orders-cards-wrapper .client-name {
    font-size: 0.875rem;
  }

  .table-header th,
  .table-cell {
    padding: 1rem 1.25rem;
    font-size: 0.8125rem;
  }

  .table-cell-id,
  .table-cell-date {
    width: auto;
  }

  .pagination {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
    padding: 1.25rem 1.5rem;
  }

  .pagination-button {
    width: 100%;
    justify-content: center;
  }

  .more-filters-dropdown {
    right: auto;
    left: 0;
    min-width: calc(100vw - 2rem);
    max-width: 320px;
  }
}

@media (max-width: 640px) {
  .orders-page {
    padding: 0.75rem;
  }

  .orders-title {
    font-size: 1.875rem;
  }

  .orders-title::after {
    width: 50px;
    height: 4px;
  }

  .orders-filters {
    padding: 1.25rem;
  }

  .orders-cards-grid {
    padding: 0.625rem 0.75rem;
    gap: 0.5rem;
  }

  .orders-cards-wrapper .order-card {
    padding: 0.5rem 0.75rem;
    flex-direction: column;
    align-items: flex-start;
  }

  .orders-cards-wrapper .order-card-main {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    width: 100%;
  }

  .orders-cards-wrapper .order-card-sections {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    width: 100%;
  }

  .orders-cards-wrapper .order-card-section-companies {
    text-align: left;
  }

  .orders-cards-wrapper .order-card-footer {
    padding-left: 0;
    padding-top: 0.5rem;
    border-left: none;
    border-top: 1px solid #f3f4f6;
    width: 100%;
    align-items: flex-start;
  }

  .orders-cards-wrapper .order-card-meta {
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    gap: 0.75rem;
  }

  .orders-cards-wrapper .order-card-sections {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .orders-cards-wrapper .order-card-section-companies {
    grid-column: 1;
    text-align: left;
  }

  .orders-cards-wrapper .order-card-title {
    font-size: 1rem;
  }

  .orders-cards-wrapper .order-card-description {
    font-size: 0.875rem;
  }

  .orders-cards-wrapper .client-name {
    font-size: 0.8125rem;
  }

  .orders-cards-wrapper .order-card-date,
  .orders-cards-wrapper .order-card-companies {
    font-size: 0.75rem;
  }

  .table-header th,
  .table-cell {
    padding: 0.875rem 1rem;
    font-size: 0.75rem;
  }

  .order-id {
    font-size: 0.75rem;
    padding: 0.375rem 0.625rem;
  }

  /* Status badge responsive styles moved to status-badge.css */

  .action-link {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }

  .empty-state-icon {
    font-size: 3.5rem;
  }

  .empty-state-text {
    font-size: 1.125rem;
  }

  .empty-state-subtext {
    font-size: 0.875rem;
  }
}

/* Focus states for accessibility */
.filter-input:focus,
.filter-select:focus,
.more-filters-button:focus,
.search-button:focus,
.reset-button:focus,
.action-link:focus,
.pagination-button:focus {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

/* Print Styles */
@media print {
  .orders-page {
    background: white;
    margin-top: 0;
  }

  .orders-filters,
  .pagination {
    display: none;
  }

  .orders-table-container {
    box-shadow: none;
    border: 1px solid #e5e7eb;
  }

  .table-row:hover {
    background: white;
    transform: none;
    box-shadow: none;
  }
}

/* ==========================================================
   ORDERS MOBILE ADAPTATION (aligned with Users/Complaints)
   ========================================================== */
@media (max-width: 768px) {
  .orders-content-surface {
    padding: 14px;
  }

  .orders-csv-export-wrap {
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
  }

  .orders-csv-button {
    width: 100%;
    justify-content: center;
  }

  .orders-page .search-main-row {
    gap: 10px;
  }

  .orders-page .search-input-wrapper,
  .orders-page .search-status-wrapper,
  .orders-page .search-actions-unified,
  .orders-page .search-actions-unified > * {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    flex: 1 1 100%;
  }

  .orders-page .search-actions-unified {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .orders-page .sort-menu-wrapper,
  .orders-page .sort-menu-button {
    width: 100%;
  }

  .orders-page .sort-menu-dropdown {
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    min-width: 100% !important;
    transform: none !important;
  }
}

@media (max-width: 480px) {
  .orders-content-surface {
    padding: 12px;
    border-radius: 10px;
  }

  .orders-page .cards-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .orders-page .item-card {
    padding: 10px 12px;
  }

  .orders-page .card-title {
    font-size: 0.95rem !important;
  }

  .orders-page .orders-pager {
    gap: 8px;
  }

  .orders-page .orders-pager-controls {
    width: 100%;
    flex-wrap: wrap;
    gap: 8px;
  }

  .orders-page .orders-pager-pages {
    order: 3;
    width: 100%;
    justify-content: center;
  }

  .orders-page .orders-pager-nav,
  .orders-page .orders-pager-size {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 4px);
    justify-content: center;
  }
}
/* Тёмная тема (DEV): легаси-контейнеры таблицы использовали сплошной
   белый фон. Актуальная таблица уже на токенах, но подстрахуемся. */
:root[data-theme='dark'] .orders-table-container,
:root[data-theme='dark'] .table-body,
:root[data-theme='dark'] .pagination-info {
  background: var(--bg-card);
}
`, "",{"version":3,"sources":["webpack://./src/css/orders.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;EACjD,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,iCAAiC;EACjC,+BAA+B;EAC/B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yEAAyE;EACzE,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,oBAAoB;EACpB,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,+CAA+C;AACjD;;;;AAIA,iCAAiC;;AAEjC,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,iBAAiB;EACjB,mBAAmB;EACnB;iCAC+B;EAC/B,gBAAgB;EAChB,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6CAA6C;;AAE7C,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+DAA+D;EAC/D,oBAAoB;EACpB,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qDAAqD;;AAErD,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,+BAA+B;EAC/B,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;;EAEE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,OAAO;IACP,6BAA6B;IAC7B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA,6DAA6D;;EAE7D;IACE,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,mCAAmC;AACnC;;;;;;;EAOE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;+DAE+D;AAC/D;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;;;;IAIE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;EACV;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,uBAAuB;EACzB;;EAEA;;IAEE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,uBAAuB;EACzB;AACF;AACA;oEACoE;AACpE;;;EAGE,0BAA0B;AAC5B","sourcesContent":["/* Orders Page Styles - Beautiful Design */\n\n@keyframes ordersPageFade {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.orders-page {\n  padding: 0;\n  max-width: 1400px;\n  margin: 0 auto;\n  min-height: calc(100vh - 80px);\n  background: transparent;\n  font-family: var(--font-body);\n  animation: ordersPageFade 0.35s ease-out;\n}\n\n/* Header Section */\n.orders-header {\n  margin-bottom: 2.5rem;\n  text-align: center;\n}\n\n/* Sort Container */\n.orders-sort-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n/* Unified surface from sort controls through orders list */\n.orders-content-surface {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n  padding: 24px;\n  margin-bottom: 2rem;\n}\n\n/* Shared rounded surface only for controls area (sort + filters) */\n.orders-controls-surface {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  margin-bottom: 2rem;\n  box-shadow: none;\n}\n\n.orders-csv-export-wrap {\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.orders-csv-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.orders-more-filters-inline {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.orders-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 1rem;\n  letter-spacing: -0.02em;\n  position: relative;\n  display: inline-block;\n}\n\n/* Filters Section */\n.orders-filters {\n  background: var(--bg-secondary);\n  border-radius: 16px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border-color);\n  border: 1px solid var(--border-color);\n}\n\n.filters-form {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.25rem;\n  align-items: end;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.orders-page .search-panel .filter-group {\n  gap: 4px;\n}\n\n.orders-page .search-panel .filter-label {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n  margin-bottom: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start !important;\n  text-align: left !important;\n  padding-left: 2px;\n  letter-spacing: 0.35px;\n}\n\n.orders-page .search-panel .filter-input,\n.orders-page .search-panel .filter-select {\n  border-radius: 10px;\n  background: var(--bg-primary);\n}\n\n.filter-input,\n.filter-select {\n  width: 100%;\n  padding: 0.875rem 1.125rem;\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  font-size: 0.9375rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.filter-input:focus,\n.filter-select:focus {\n  outline: none;\n  border-color: var(--accent-color);\n  background: var(--bg-secondary);\n  box-shadow: 0 0 0 3px var(--nav-active-bg);\n  transform: translateY(-1px);\n}\n\n.filter-input::placeholder {\n  color: #94a3b8;\n}\n\n/* Search Panel Wrapper */\n.search-panel-wrapper {\n  position: relative;\n  margin-bottom: 0;\n}\n\n/* More Filters Menu */\n.more-filters-wrapper {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 10;\n}\n\n.more-filters-menu {\n  position: relative;\n  display: inline-block;\n}\n\n.more-filters-button {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 2px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  text-align: center;\n  font-family: inherit;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.more-filters-button:hover {\n  border-color: var(--accent-color);\n  background: var(--bg-primary);\n  color: var(--accent-color);\n}\n\n.more-filters-button.has-filters {\n  border-color: var(--accent-color);\n  background: rgba(79, 70, 229, 0.05);\n  color: var(--accent-color);\n}\n\n.more-filters-icon {\n  font-size: 1.25rem;\n  line-height: 1;\n  font-weight: 700;\n  letter-spacing: 1px;\n  transform: rotate(90deg);\n}\n\n.more-filters-badge {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 8px;\n  height: 8px;\n  background: var(--accent-primary);\n  border-radius: 50%;\n  border: 2px solid white;\n  box-shadow: none;\n}\n\n.more-filters-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 280px;\n  background: var(--bg-primary);\n  border-radius: 12px;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-color);\n  z-index: 1000;\n  overflow: hidden;\n}\n\n@media (max-width: 768px) {\n  .orders-content-surface {\n    border-radius: 12px;\n    padding: 16px;\n  }\n\n  .orders-controls-surface {\n    border-radius: 0;\n    padding: 0;\n  }\n\n  .orders-sort-container {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .orders-more-filters-inline {\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .more-filters-menu {\n    width: 100%;\n  }\n\n  .more-filters-dropdown {\n    left: 0;\n    right: 0;\n    width: 100%;\n    min-width: 0;\n  }\n\n  .more-filters-wrapper {\n    top: 0.75rem;\n    right: 0.75rem;\n  }\n\n  .more-filters-button {\n    width: 36px;\n    height: 36px;\n  }\n\n  .more-filters-icon {\n    font-size: 1.1rem;\n  }\n}\n\n.more-filters-header {\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--bg-primary);\n}\n\n.more-filters-title {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.more-filters-content {\n  padding: 1rem 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.more-filters-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.more-filters-label {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: 0.25rem;\n}\n\n.more-filters-input {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 2px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 0.875rem;\n  transition: all 0.3s ease;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-family: inherit;\n}\n\n.more-filters-input:focus {\n  outline: none;\n  border-color: var(--accent-color);\n  background: var(--bg-secondary);\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.more-filters-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  padding: 0.5rem 0;\n  user-select: none;\n}\n\n.more-filters-checkbox {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: var(--accent-primary);\n  flex-shrink: 0;\n}\n\n.more-filters-checkbox-text {\n  font-size: 0.9375rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  transition: color 0.3s ease;\n}\n\n.more-filters-checkbox-label:hover .more-filters-checkbox-text {\n  color: var(--accent-primary);\n}\n\n.filters-actions {\n  display: flex;\n  gap: 0.875rem;\n  align-items: center;\n}\n\n.search-button,\n.reset-button {\n  padding: 0.875rem 1.75rem;\n  border: none;\n  border-radius: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 0.9375rem;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.search-button {\n  background: var(--accent-color);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.search-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  background: var(--accent-hover);\n  box-shadow: var(--shadow-md);\n}\n\n.search-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.reset-button {\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  border: 1px solid var(--border-color);\n}\n\n.reset-button:hover {\n  background: var(--nav-hover-bg);\n  border-color: var(--text-secondary);\n  color: var(--text-primary);\n  transform: translateY(-2px);\n}\n\n.button-icon {\n  font-size: 1rem;\n  display: inline-block;\n  transition: transform 0.3s ease;\n}\n\n.search-button:hover .button-icon {\n  transform: rotate(15deg) scale(1.1);\n}\n\n.reset-button:hover .button-icon {\n  transform: rotate(180deg);\n}\n\n/* Error Message */\n.error-message {\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  color: #dc2626;\n  padding: 1.25rem 1.75rem;\n  border-radius: 12px;\n  margin-bottom: 1.5rem;\n  border: 2px solid #fecaca;\n  font-weight: 600;\n  text-align: center;\n  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.15);\n  animation: slideUp 0.4s ease-out 0.2s backwards;\n}\n\n\n\n/* Grid is handled by cards.css */\n\n/* Empty State */\n.orders-cards-wrapper .empty-state {\n  padding: 4rem 2rem;\n  text-align: center;\n  background: transparent;\n  border-radius: 16px;\n  box-shadow: none;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n/* Loading State */\n.orders-cards-wrapper .loading-state {\n  padding: 4rem 2rem;\n  text-align: center;\n  background: transparent;\n  border-radius: 16px;\n  box-shadow: none;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n/* Pagination */\n.orders-cards-wrapper .pagination {\n  margin-top: 0;\n  border-top: 1px solid var(--border-color);\n  border-radius: 12px;\n  background: transparent;\n  border-left: none;\n  border-right: none;\n  border-bottom: none;\n  box-shadow: none;\n}\n\n/* Table Section - keeping for backward compatibility if needed */\n.orders-table-container {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08),\n    0 1px 3px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  animation: slideUp 0.4s ease-out 0.25s backwards;\n}\n\n.table-responsive {\n  overflow-x: auto;\n}\n\n/* Loader removed to avoid global conflicts */\n\n/* Table Styles */\n.orders-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.orders-table th,\n.orders-table td {\n  vertical-align: middle;\n}\n\n.table-header {\n  background: var(--bg-primary);\n  border-bottom: 3px solid var(--border-color);\n}\n\n.table-header th {\n  padding: 0.8rem 0.9rem;\n  text-align: left;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  white-space: nowrap;\n  position: relative;\n}\n\n.table-header th::after {\n  content: '';\n  position: absolute;\n  bottom: -3px;\n  left: 0;\n  width: 0;\n  height: 3px;\n  background: var(--accent-primary);\n  transition: width 0.3s ease;\n}\n\n.table-header th:hover::after {\n  width: 100%;\n}\n\n.table-body {\n  background: white;\n}\n\n.table-row {\n  border-bottom: 1px solid #eef2f7;\n  transition: background-color 0.2s ease;\n  animation: fadeInRow 0.28s ease-out backwards;\n}\n\n@keyframes fadeInRow {\n  from {\n    opacity: 0;\n    transform: translateX(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.table-row:nth-child(1) {\n  animation-delay: 0.1s;\n}\n\n.table-row:nth-child(2) {\n  animation-delay: 0.15s;\n}\n\n.table-row:nth-child(3) {\n  animation-delay: 0.2s;\n}\n\n.table-row:nth-child(4) {\n  animation-delay: 0.25s;\n}\n\n.table-row:nth-child(5) {\n  animation-delay: 0.3s;\n}\n\n.table-row:hover {\n  background: var(--bg-secondary);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  transform: none;\n}\n\n.table-cell {\n  padding: 0.7rem 0.9rem;\n  vertical-align: middle;\n}\n\n.table-cell-id {\n  width: 130px;\n}\n\n.table-cell-title {\n  min-width: 220px;\n  max-width: 320px;\n}\n\n.table-cell-client {\n  min-width: 160px;\n  max-width: 220px;\n  text-align: left;\n  vertical-align: middle;\n}\n\n.table-cell-status {\n  width: 180px;\n}\n\n.table-cell-date {\n  width: 170px;\n  white-space: nowrap;\n}\n\n.table-cell-actions {\n  width: 130px;\n  text-align: center;\n}\n\n.order-id {\n  font-family: 'Monaco', 'Consolas', 'Liberation Mono', monospace;\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n  background: var(--nav-hover-bg);\n  padding: 0.35rem 0.65rem;\n  border-radius: 8px;\n  display: inline-block;\n  cursor: help;\n  border: 1px solid var(--border-color);\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.order-id:hover {\n  background: var(--nav-hover-bg);\n  transform: scale(1.05);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.order-title {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 0.9375rem;\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.order-client {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: 1.25;\n}\n\n.order-date {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n/* Status Badges - styles moved to status-badge.css */\n\n/* Action Links */\n.action-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.625rem 1.25rem;\n  background: var(--accent-color);\n  color: white;\n  text-decoration: none;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.875rem;\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-sm);\n  position: relative;\n  overflow: hidden;\n}\n\n.action-link::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  transform: translate(-50%, -50%);\n  transition: width 0.6s, height 0.6s;\n}\n\n.action-link:hover::before {\n  width: 300px;\n  height: 300px;\n}\n\n.action-link:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n  text-decoration: none;\n  color: white;\n}\n\n.action-icon {\n  font-size: 1rem;\n  transition: transform 0.3s ease;\n}\n\n.action-link:hover .action-icon {\n  transform: translateX(4px);\n}\n\n/* Empty State */\n.empty-state {\n  padding: 4rem 2rem;\n  text-align: center;\n}\n\n.empty-state-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.empty-state-icon {\n  font-size: 4.5rem;\n  margin-bottom: 0.5rem;\n  opacity: 0.6;\n  animation: float 3s ease-in-out infinite;\n}\n\n@keyframes float {\n\n  0%,\n  100% {\n    transform: translateY(0px);\n  }\n\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.empty-state-text {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-top: 0.5rem;\n}\n\n.empty-state-subtext {\n  font-size: 0.9375rem;\n  color: var(--text-secondary);\n  margin-top: 0.25rem;\n}\n\n.empty-state td {\n  padding: 4rem 2rem;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 2rem;\n  border-top: 2px solid var(--border-color);\n  background: var(--bg-primary);\n}\n\n.pagination-button {\n  background: var(--accent-color);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  padding: 0.75rem 1.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: var(--shadow-sm);\n  position: relative;\n  overflow: hidden;\n}\n\n.pagination-button::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  transform: translate(-50%, -50%);\n  transition: width 0.6s, height 0.6s;\n}\n\n.pagination-button:hover:not(:disabled)::before {\n  width: 300px;\n  height: 300px;\n}\n\n.pagination-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.pagination-button:disabled {\n  background: var(--border-color);\n  color: #94a3b8;\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.pagination-icon {\n  font-size: 1rem;\n  transition: transform 0.3s ease;\n}\n\n.pagination-button:hover:not(:disabled) .pagination-icon {\n  transform: translateX(-4px);\n}\n\n.pagination-button.next:hover:not(:disabled) .pagination-icon {\n  transform: translateX(4px);\n}\n\n.pagination-info {\n  color: var(--text-secondary);\n  font-weight: 600;\n  font-size: 0.9375rem;\n  background: white;\n  padding: 0.75rem 1.5rem;\n  border-radius: 10px;\n  border: 2px solid var(--border-color);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .filters-form {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .orders-page {\n    padding: 1.5rem;\n  }\n\n  .orders-cards-grid {\n    gap: 0.625rem;\n    padding: 0.875rem 1.25rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .orders-page {\n    padding: 1rem;\n  }\n\n  .orders-title {\n    font-size: 2.25rem;\n  }\n\n  .orders-title::after {\n    width: 60px;\n  }\n\n  .filters-form {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .filters-actions {\n    flex-direction: column;\n  }\n\n  .orders-filters {\n    padding: 1.5rem;\n  }\n\n  .orders-cards-grid {\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n  }\n\n  .orders-cards-wrapper .order-card {\n    padding: 0.625rem 0.875rem;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .orders-cards-wrapper .order-card-main {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n    width: 100%;\n  }\n\n  .orders-cards-wrapper .order-card-sections {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n    width: 100%;\n  }\n\n  .orders-cards-wrapper .order-card-section-companies {\n    text-align: left;\n  }\n\n  .orders-cards-wrapper .order-card-footer {\n    padding-left: 0;\n    padding-top: 0.5rem;\n    border-left: none;\n    border-top: 1px solid #f3f4f6;\n    width: 100%;\n    align-items: flex-start;\n  }\n\n  .orders-cards-wrapper .order-card-meta {\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .orders-cards-wrapper .order-card-sections {\n    grid-template-columns: 1fr 1fr;\n    gap: 0.75rem;\n  }\n\n  .orders-cards-wrapper .order-card-section-companies {\n    grid-column: 1 / -1;\n    text-align: right;\n  }\n\n  .orders-cards-wrapper .order-card-title {\n    font-size: 1.0625rem;\n  }\n\n  .orders-cards-wrapper .order-card-description {\n    font-size: 0.9375rem;\n  }\n\n  .orders-cards-wrapper .client-name {\n    font-size: 0.875rem;\n  }\n\n  .table-header th,\n  .table-cell {\n    padding: 1rem 1.25rem;\n    font-size: 0.8125rem;\n  }\n\n  .table-cell-id,\n  .table-cell-date {\n    width: auto;\n  }\n\n  .pagination {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n    padding: 1.25rem 1.5rem;\n  }\n\n  .pagination-button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .more-filters-dropdown {\n    right: auto;\n    left: 0;\n    min-width: calc(100vw - 2rem);\n    max-width: 320px;\n  }\n}\n\n@media (max-width: 640px) {\n  .orders-page {\n    padding: 0.75rem;\n  }\n\n  .orders-title {\n    font-size: 1.875rem;\n  }\n\n  .orders-title::after {\n    width: 50px;\n    height: 4px;\n  }\n\n  .orders-filters {\n    padding: 1.25rem;\n  }\n\n  .orders-cards-grid {\n    padding: 0.625rem 0.75rem;\n    gap: 0.5rem;\n  }\n\n  .orders-cards-wrapper .order-card {\n    padding: 0.5rem 0.75rem;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .orders-cards-wrapper .order-card-main {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n    width: 100%;\n  }\n\n  .orders-cards-wrapper .order-card-sections {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n    width: 100%;\n  }\n\n  .orders-cards-wrapper .order-card-section-companies {\n    text-align: left;\n  }\n\n  .orders-cards-wrapper .order-card-footer {\n    padding-left: 0;\n    padding-top: 0.5rem;\n    border-left: none;\n    border-top: 1px solid #f3f4f6;\n    width: 100%;\n    align-items: flex-start;\n  }\n\n  .orders-cards-wrapper .order-card-meta {\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n    justify-content: space-between;\n    gap: 0.75rem;\n  }\n\n  .orders-cards-wrapper .order-card-sections {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n\n  .orders-cards-wrapper .order-card-section-companies {\n    grid-column: 1;\n    text-align: left;\n  }\n\n  .orders-cards-wrapper .order-card-title {\n    font-size: 1rem;\n  }\n\n  .orders-cards-wrapper .order-card-description {\n    font-size: 0.875rem;\n  }\n\n  .orders-cards-wrapper .client-name {\n    font-size: 0.8125rem;\n  }\n\n  .orders-cards-wrapper .order-card-date,\n  .orders-cards-wrapper .order-card-companies {\n    font-size: 0.75rem;\n  }\n\n  .table-header th,\n  .table-cell {\n    padding: 0.875rem 1rem;\n    font-size: 0.75rem;\n  }\n\n  .order-id {\n    font-size: 0.75rem;\n    padding: 0.375rem 0.625rem;\n  }\n\n  /* Status badge responsive styles moved to status-badge.css */\n\n  .action-link {\n    padding: 0.5rem 1rem;\n    font-size: 0.8125rem;\n  }\n\n  .empty-state-icon {\n    font-size: 3.5rem;\n  }\n\n  .empty-state-text {\n    font-size: 1.125rem;\n  }\n\n  .empty-state-subtext {\n    font-size: 0.875rem;\n  }\n}\n\n/* Focus states for accessibility */\n.filter-input:focus,\n.filter-select:focus,\n.more-filters-button:focus,\n.search-button:focus,\n.reset-button:focus,\n.action-link:focus,\n.pagination-button:focus {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n/* Print Styles */\n@media print {\n  .orders-page {\n    background: white;\n    margin-top: 0;\n  }\n\n  .orders-filters,\n  .pagination {\n    display: none;\n  }\n\n  .orders-table-container {\n    box-shadow: none;\n    border: 1px solid #e5e7eb;\n  }\n\n  .table-row:hover {\n    background: white;\n    transform: none;\n    box-shadow: none;\n  }\n}\n\n/* ==========================================================\n   ORDERS MOBILE ADAPTATION (aligned with Users/Complaints)\n   ========================================================== */\n@media (max-width: 768px) {\n  .orders-content-surface {\n    padding: 14px;\n  }\n\n  .orders-csv-export-wrap {\n    width: 100%;\n    margin-left: 0;\n    margin-top: 10px;\n  }\n\n  .orders-csv-button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .orders-page .search-main-row {\n    gap: 10px;\n  }\n\n  .orders-page .search-input-wrapper,\n  .orders-page .search-status-wrapper,\n  .orders-page .search-actions-unified,\n  .orders-page .search-actions-unified > * {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    flex: 1 1 100%;\n  }\n\n  .orders-page .search-actions-unified {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .orders-page .sort-menu-wrapper,\n  .orders-page .sort-menu-button {\n    width: 100%;\n  }\n\n  .orders-page .sort-menu-dropdown {\n    left: 0 !important;\n    right: 0 !important;\n    width: 100% !important;\n    min-width: 100% !important;\n    transform: none !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .orders-content-surface {\n    padding: 12px;\n    border-radius: 10px;\n  }\n\n  .orders-page .cards-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .orders-page .item-card {\n    padding: 10px 12px;\n  }\n\n  .orders-page .card-title {\n    font-size: 0.95rem !important;\n  }\n\n  .orders-page .orders-pager {\n    gap: 8px;\n  }\n\n  .orders-page .orders-pager-controls {\n    width: 100%;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .orders-page .orders-pager-pages {\n    order: 3;\n    width: 100%;\n    justify-content: center;\n  }\n\n  .orders-page .orders-pager-nav,\n  .orders-page .orders-pager-size {\n    flex: 1 1 calc(50% - 4px);\n    justify-content: center;\n  }\n}\n/* Тёмная тема (DEV): легаси-контейнеры таблицы использовали сплошной\n   белый фон. Актуальная таблица уже на токенах, но подстрахуемся. */\n:root[data-theme='dark'] .orders-table-container,\n:root[data-theme='dark'] .table-body,\n:root[data-theme='dark'] .pagination-info {\n  background: var(--bg-card);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
